export default [
  {
    id: 1,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">물(안전보건규칙 제571조)</div>' +
      '<div>- 깨끗하고 시원한 물을 제공하는지</div>' +
      '</div>',
    is_checked: '',
    note: '',
  },
  {
    id: 2,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">그늘(안전보건규칙 제567조제2항)</div>' +
      '<div> - 깨끗하고 시원한 물을 제공하는지</div>' +
      '<div> - 제공된 그늘에 휴식할 수 있는 의자 등이 비치되어 있는지</div>' +
      '</div>',
    is_checked: '',
    note: '',
  },
  {
    id: 3,
      html: '<div style="font-weight: 400">' +
        '<div style="font-weight: 500">휴식(안전보건규칙 제566조)</div>' +
        '<div> - 휴식시간이 적절히 부여되는지</div>' +
        '</div>',
    is_checked: '',
    note: '',
  },
  {
    id: 4,
    label: '온열질환 예방가이드 게시 여부',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
    titleColor: '#F9F9F9',
  },
  {
    id: 5,
    label: '폭염 위험단계별 대응요령 숙지 및 준수여부',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
  {
    id: 6,
    label: '폭염시 근로자가 건강상의 이유로 작업중지를 요청할 경우 즉시 조치',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
  {
    id: 7,
    label: '온열질환 예방에 관한 교육 여부',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
  {
    id: 8,
    label: '식염포도당 및 이온음료 제공 및 위치 공유',
    is_checked: '',
    note: '',
    title: '기타(권장사항)',
  },
];
